import * as z from "zod";

export const putOdooIntegration = {
  name: "putOdooIntegration" as const,
  input: z.object({
    apiKey: z.string().optional(),
    url: z.string(),
    database: z.string(),
    username: z.string(),
    version: z.union([z.literal(16), z.literal(17)]),
    autoPostCreditNotes: z.boolean(),
  }),
  output: z.object({}),
};
